import { b as __awaiter, c as __generator } from '../tslib.es6-604585c1.js';
import fetchFactory from '../fetchFactory/index.js';
import { RequestHeaders, ResponseStatus, defaultErrorMessage } from '../configs/constants/index.js';
import { removeStorage } from '../services/browserStorage/index.js';

var validateAdditionalInfo = function validateAdditionalInfo(additionalInfo) {
  for (var objKey in additionalInfo) {
    var validationRules = additionalInfo[objKey];
    for (var _i = 0, validationRules_1 = validationRules; _i < validationRules_1.length; _i++) {
      var rule = validationRules_1[_i];
      var type = rule.type,
        message = rule.message;
      if (type === 'cantContain') {
        return message;
      }
    }
    return undefined;
  }
};

var _a;
var fetch = fetchFactory({
  baseUrl: '',
  withCache: false,
  headers: (_a = {}, _a[RequestHeaders.platform] = 'website', _a),
  withDeviceId: true,
  withLanguageHeader: true
});
var fetcher = function fetcher(url, options) {
  return fetch(url, options).then(function (response) {
    return __awaiter(void 0, void 0, void 0, function () {
      var responseData, message, status, reason, additionalError, errorObject;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, response.clone().json()];
          case 1:
            responseData = _a.sent();
            message = responseData.message, status = responseData.status, reason = responseData.reason;
            if (!response.ok || status === ResponseStatus.error) {
              if (responseData === null || responseData === void 0 ? void 0 : responseData.additional_info) {
                additionalError = validateAdditionalInfo(responseData.additional_info);
              }
              errorObject = {
                statusCode: response.status,
                message: additionalError || message || defaultErrorMessage,
                reason: reason,
                url: url
              };
              return [2, Promise.reject(errorObject)];
            }
            return [2, Promise.resolve(responseData)];
        }
      });
    });
  })["catch"](function (e) {
    removeStorage(url, false);
    return Promise.reject(e);
  });
};

export { fetcher as default };
//# sourceMappingURL=index.js.map
